<script setup lang="ts">
import { ChevronDown, FlaskConical } from 'lucide-vue-next'
import { useQraVersion } from '~/composables/useQraVersion'
import type { QraVersion } from '~~/shared/chat/qraVersion'

const { qraVersion, setQraVersion, options } = useQraVersion()

const currentLabel = computed(() => options.value.find(o => o.id === qraVersion.value)?.label ?? 'QRA 2.1 (skill)')

function onChange(e: Event) {
  setQraVersion((e.target as HTMLSelectElement).value as QraVersion)
}
</script>

<template>
  <!-- Superadmin-only: `options` is empty for everyone else, so this renders nothing. -->
  <div v-if="options.length > 1" class="qra-selector" title="QRA version (superadmin)">
    <FlaskConical class="qra-icon" />
    <select
      :value="qraVersion"
      class="qra-select"
      @change="onChange"
    >
      <option v-for="opt in options" :key="opt.id" :value="opt.id">
        {{ opt.label }}
      </option>
    </select>
    <span class="qra-label">{{ currentLabel }}</span>
    <ChevronDown class="qra-chevron" />
  </div>
</template>

<style scoped>
@reference "~/assets/css/tailwind.css";
.qra-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.qra-select {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  -webkit-appearance: none;
  appearance: none;
}

.qra-icon {
  width: 0.75rem;
  height: 0.75rem;
  @apply text-muted-foreground;
  pointer-events: none;
}

.qra-label {
  font-size: 0.75rem;
  @apply text-muted-foreground;
  user-select: none;
  pointer-events: none;
}

.qra-chevron {
  width: 0.75rem;
  height: 0.75rem;
  @apply text-muted-foreground;
  pointer-events: none;
}

.qra-selector:hover .qra-label,
.qra-selector:hover .qra-chevron {
  @apply text-foreground;
}
</style>
